import React from 'react'
import { Form, Card, Input, Button, notification, Select } from 'antd'
import gql from '../../api/gql'
import * as _ from "lodash"
const { Option } = Select;

class PaymentSettingsForm extends React.Component {
  state = {
    initSetting: []
  }
  componentDidMount = () => {
    const query = `query getAppSettings($input: [String!]){
      getAppSettings(input: $input){
        name
        value
      }
    }`
    const input = ["payment_mode", "payment_sandbox_key", "payment_production_key"]
    this.setState({ loading: true })
    gql.request(query, { input: input })
      .then(res =>
        this.setState({ initSetting: res.getAppSettings || [], loading: false }))
      .catch(err => {
        notification["error"]({
          message: 'Error',
          description: _.get(err, "[0].message")
        })
        this.setState({ loading: false })
      })
  }
  render() {
    const { loading, form, onSubmit } = this.props
    const { initSetting } = this.state
    const setting = initSetting && initSetting.reduce((init, item) => ({ ...init, [item.name]: item.value }), {})
    const { getFieldDecorator } = form
    return (
      <Form
        loading={loading}
        onSubmit={e => {
          e.preventDefault()
          this.props.form.validateFields((err, values) => {
            if (!err) {
              onSubmit(values)
            } else {
              notification.error({ message: 'Form is invalid' })
            }
          })
        }}
      >
        <Card title="Payment settings">
          <Form.Item label="Payment mode">
            {getFieldDecorator('payment_mode', {
              initialValue: setting ? setting['payment_mode'] : ''
            })(<Select
              style={{ width: 200 }}
              placeholder="Select payment mode"
            >
              <Option value="sandbox">Sandbox</Option>
              <Option value="production">Production</Option>
            </Select>)}
          </Form.Item>
          <Form.Item label="Sandbox key">
            {getFieldDecorator('payment_sandbox_key', {
              initialValue: setting ? setting['payment_sandbox_key'] : ''
            })(<Input />)}
          </Form.Item>
          <Form.Item label="Production key">
            {getFieldDecorator('payment_production_key', {
              initialValue: setting ? setting['payment_production_key'] : ''
            })(<Input />)}
          </Form.Item>
        </Card>
        <Form.Item style={{ textAlign: 'right', marginTop: 20 }}>
          <Button icon="save" type='primary' htmlType='submit'>Save</Button>
        </Form.Item>
      </Form>
    )
  }
}

export default Form.create({ name: 'form' })(PaymentSettingsForm)